import React from 'react';

const DeliverySheetComponentLoadable = React.lazy(() => import('../DeliverySheetComponent/DeliverySheet/DeliverySheetComponent'));
const DeliverySheetTableComponentLoadable = React.lazy(() => import('../DeliverySheetComponent/DeliverySheetTableComponent'));
const DeliverySheetDetailsComponentLoadable = React.lazy(() => import('../DeliverySheetComponent/DeliverySheet/DeliverySheetDetailsComponent'));
export {
    DeliverySheetTableComponentLoadable,
    DeliverySheetComponentLoadable,
    DeliverySheetDetailsComponentLoadable
};
